import api from '../../../services/api';
import { readPage } from '../../../utils/apiResult';

// Aday etiketi KATALOĞU (kiracı başına): SPEC F1
//   GET    v1/ats-candidate-tags            (AT.Read — liste süzgeci ve profil okur)
//   POST   v1/ats-candidate-tags            { name (≤40), color (hex) }   AT.Write
//   PUT    v1/ats-candidate-tags/{id}                                     AT.Write
//   DELETE v1/ats-candidate-tags/{id}                                     AT.Write
// (TenantId, lower(Name)) tekildir — mükerrer ad sunucuda reddedilir.
export const TAGS_ROOT = '/v1/ats-candidate-tags';

export const TAG_NAME_MAX = 40;

export const fetchTagCatalog = async () => {
  const res = await api.get(TAGS_ROOT, { params: { pageSize: 500, pageNumber: 1 } });
  const { ok, items } = readPage(res);
  return { ok, items };
};
